module.exports = "./img/0cc1cece440ff420f6a788ca8310372d.jpg";